<template>
  <b-modal
    hide-footer
    centered
    size="lg"
    ref="edit-travel-modal"
    id="add-travel-modal"
    title="Editar Despesa">
    <template #modal-header>
        <!-- <div class="head-modal">
            <h1 id="title-modal">EDITAR DESPESA</h1>
        </div>
        <button id="btn-cancel" @click="close()">X</button> -->
    </template>
    <div class="p-2">
        <div class="d-flex justify-content-between pt-2">
            <h2 id="titile-modal">{{dataObj.despesaTipo == undefined ? 'N/D' : dataObj.despesaTipo.nome}}</h2>
            <button @click="copyValue" id="btn-copy"><i class="fas fa-clone mr-2"></i>COPIAR VALOR</button>
        </div>
        <hr>
         <div class="d-flex mt-2">
            <div class="col-md-4">
                <div>
                    <p class="info-title">Quantidade Prevista</p>
                    <p class="resul-info">{{dataObj.quantidade}}</p>
                </div>
            </div>
            <div class="col-md-4">
                <div>
                  <p class="info-title">Valor unitário Previsto</p>
                  <p class="resul-info">{{formatMoney(dataObj.valorUnitario)}}</p>
                </div>
            </div>
            <div class="col-md-4">
                 <div>
                  <p class="info-title">Valor total Previsto</p>
                  <p class="resul-info">{{formatMoney(dataObj.valorTotal)}}</p>
                </div>
            </div>
        </div>
        <div class="d-flex mb-4">
             <div class="col-md-4">
                  <label class="label-form"  for="txtGroupsName"><small class="text-danger">*</small> Quantidade:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
                      <money class="form-control form-control-10 text-right"
                        v-bind="integerFormat"
                        placeholder="0"
                        @blur.native="calcularTotal"
                        v-model="formData.quantidade"
                        />
                  </div>
              </div>
              <div class="col-md-4">
                  <label class="label-form"><small class="text-danger">*</small> Valor:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
                      <money class="form-control form-control-10 text-right"
                      v-bind="moneyFormat"
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      @blur.native="calcularTotal"
                      v-model="formData.valorUnitario"
                      />
                  </div>
              </div>
              <div class="col-md-4">
                  <label class="label-form"><small class="text-danger">*</small>Valor Total:</label>
                  <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
                      <money class="form-control form-control-10 text-right text-bold"
                      v-bind="moneyFormat"
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      v-model="formData.total"
                      :size="form.total.maxlength"
                      :required="form.total.required"
                      :state="form.total.state"
                      :disabled="true"/>
                  </div>
              </div>
          </div>
        <p class="info-title" >Observação</p>
        <textarea rows="4" v-model="formData.Observacao" placeholder="Adicione uma breve observação sobre a despesa" class="form-control"> </textarea>
        <div class="d-flex justify-content-center mt-4">
            <button class="btn-cancel mr-2">CANCELAR</button>
            <button class="btn-add ml-2" @click="sendData">ADICIONAR</button>
        </div>
    </div>
  </b-modal>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'ModalEditDespesas',
  data () {
    return {
      dataObj: [],
      formData: {
        valorUnitario: 0,
        total: 0,
        quantidade: 0,
        Obs: ''
      },
      form: {
        valorUnitario: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        quantidade: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        total: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      integerFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    show (obj) {
      this.dataObj = obj
      this.formData.valorUnitario = obj.valorUnitarioFinal
      this.formData.quantidade = obj.quantidadeFinal
      this.formData.total = obj.valorTotalFinal
      this.$refs['edit-travel-modal'].show()
    },
    close () {
      Object.keys(this.formData).forEach((Element) => {
        this.formData[Element] = null
      })
      this.$refs['edit-travel-modal'].hide()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    calcularTotal () {
      let total = this.formData.quantidade * this.formData.valorUnitario
      this.formData.total = total
    },
    copyValue () {
      this.formData.quantidade = this.dataObj.quantidade
      this.formData.valorUnitario = this.dataObj.valorUnitario
      this.formData.total = this.dataObj.valorTotal
    },
    sendData () {
      this.formData.id = this.dataObj.id
      ExpenseItemRepository.SetIncluida(this.formData)
        .then(Response => {
          if (Response.data) {
            toast.success('Item incluido com sucesso!!')
          } else {
            toast.error('Não possivel incluir o item!!')
          }
          this.close()
          this.$emit('reloadItems')
        })
        .catch(Error => console.log(Error))
    }
  }

}
</script>

<style scoped>
.btn-cancel{
    height: 45px;
    width: 250px;
    color: rgb(105, 104, 104);
    background: rgb(204, 204, 204);
     border: none;
    font-weight: bold;
    border-radius: 10px;
    font-size: 16px;
}
.btn-cancel:hover{
    background: rgb(179, 178, 178);
}
.btn-add{
    height: 45px;
    width: 250px;
    border-radius: 10px;
    color: white;
    background: #008144;
    border: none;
    font-weight: bold;
    font-size: 16px;
}
.btn-add:hover{
    background: #029450;

}
#btn-copy{
    height: 40px;
    width: 150px;
    color: #008144;
    border: 1px solid #008144;
    background: white;
    font-weight: bold;
    border-radius: 10px;
}
.head-modal{
    display: flex;
    justify-content: center;
    width: 100%;
 }
#btn-cancel{
    position: absolute;
    right: 10px;
    top: 10px;
    font-weight: bold;
    border: none;
    color: #025e33;
    width: 35px;
    font-size: 16px;
    height: 35px;
    border-radius: 50%;
 }
#btn-copy:hover{
    background: #008144;
    color: white;
}
.resul-info{
    margin-top: 0px;
    font-weight: bold;
}
.info-title{
    margin-bottom: 0px;
    font-weight: 700;
}
#titile-modal{
    font-weight: bold;
}
#title-modal{
    color: white;
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/ModalEditDespesas/ModalEditDespesas.vue